<script setup lang="ts">
import { useRoute } from "vue-router";

interface IProps {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: any;
}

const props = defineProps<IProps>();

const currentRoute = useRoute();
</script>

<template>
  <component
    :is="props.component"
    v-if="currentRoute.name === props.name"
  />
  <router-view v-else />
</template>
